import { createUseStyles } from 'react-jss';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';
import { ColorProp } from '.';

type StyleProps = {
  color: ColorProp;
};

const useStyles = createUseStyles((theme: CmsWrenchTheme) => ({
  container: ({ color }: StyleProps) => {
    const backgroundColor = (): string | undefined => {
      if (color === 'sabaeus') {
        return theme.brandColors.primary.sabaeus;
      }
      if (color === 'canvas') {
        return theme.brandColors.neutral.canvas;
      }
      return undefined;
    };
    return {
      backgroundColor: backgroundColor(),
      padding: theme.spacing[7],
    };
  },
  button: ({ color }: StyleProps) => ({
    '& > *': {
      backgroundColor: color === 'sabaeus' ? theme.brandColors.neutral.white : undefined,
      borderColor: color === 'sabaeus' ? theme.brandColors.neutral.white : undefined,
      color: color === 'sabaeus' ? theme.brandColors.primary.sabaeus : undefined,
      '&:hover, &:focus': {
        backgroundColor: color === 'sabaeus' ? theme.endpageColors.onHover.transparentWhite : undefined,
        borderColor: color === 'sabaeus' ? theme.endpageColors.onHover.transparentWhite : undefined,
        textDecoration: 'none',
      },
      '&:focus-visible': {
        // default focus outline not visible for some reason, so we have to apply manually
        outline: '2px solid #007aff',
      },
    },
  }),
  copyElement: {
    maxWidth: 550,
  },
  copyText: {
    fontWeight: 500,
  },
}));

export default useStyles;
